import { number, object } from 'yup';

const paginationNumber = number()
  .transform((value: unknown, originalValue: unknown) =>
    typeof originalValue === 'string' && originalValue.trim() === ''
      ? undefined
      : value,
  )
  .integer()
  .positive();

const schema = object({
  page: paginationNumber.default(1),
  pageSize: paginationNumber.default(10),
});

export interface PaginationSearch {
  page: number;
  pageSize: number;
}

export function parsePaginationSearch(search: Record<string, unknown>) {
  try {
    return schema.validateSync(search);
  } catch {
    return schema.getDefault();
  }
}
